import React from 'react';

export const NoPlaylistsFound = () => (
  <svg
    width="151"
    height="150"
    viewBox="0 0 151 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="150" height="150" fill="white" />
    <path
      d="M110.5 15V15C110.636 19.9133 114.587 23.8643 119.5 24V24V24C114.587 24.1357 110.636 28.0867 110.5 33V33V33C110.364 28.0867 106.413 24.1357 101.5 24V24V24C106.413 23.8643 110.364 19.9133 110.5 15V15Z"
      fill="#262626"
    />
    <path
      d="M131.5 97V97C131.636 101.913 135.587 105.864 140.5 106V106V106C135.587 106.136 131.636 110.087 131.5 115V115V115C131.364 110.087 127.413 106.136 122.5 106V106V106C127.413 105.864 131.364 101.913 131.5 97V97Z"
      fill="#262626"
    />
    <path
      d="M78.5 27L120.5 51V99L111.945 103.888L103.391 99V108.777L94.836 113.665L86.2813 108.777V118.554L78.5 123L36.5 99V51L44.7423 46.2901L52.9846 51.1045V41.5803L62.0326 36.41L70.2663 41.261V31.705L78.5 27Z"
      fill="white"
    />
    <path
      d="M120.5 51L78.5 27L70.2663 31.705M120.5 51V99L111.945 103.888M120.5 51L111.945 55.8884M78.5 123L36.5 99V51M78.5 123V75M78.5 123L86.2813 118.554V108.777M36.5 51L78.5 75M36.5 51L44.7423 46.2901L52.9846 51.1045M78.5 75L86.2813 70.5536M86.2813 70.5536V108.777M86.2813 70.5536L52.9846 51.1045M103.391 60.7768L94.836 65.6652M103.391 60.7768C103.391 71.1527 103.391 88.2573 103.391 99M103.391 60.7768L70.2663 41.261M111.945 55.8884V103.888M111.945 55.8884L70.2663 31.705M111.945 103.888L103.391 99M94.836 65.6652V113.665M94.836 65.6652L52.9846 41.5803M94.836 113.665L103.391 108.777C103.391 108.777 103.391 104.823 103.391 99M94.836 113.665L86.2813 108.777M52.9846 41.5803L62.0326 36.41L70.2663 41.261M52.9846 41.5803V51.1045M70.2663 31.705V41.261"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 59L30.018 59.6528C30.2792 69.1131 37.8869 76.7208 47.3472 76.982L48 77L47.3472 77.018C37.8869 77.2792 30.2792 84.8869 30.018 94.3472L30 95L29.982 94.3472C29.7208 84.8869 22.1131 77.2792 12.6528 77.018L12 77L12.6528 76.982C22.1131 76.7208 29.7208 69.1131 29.982 59.6528L30 59Z"
      fill="#262626"
    />
  </svg>
);
